<template>
  <transition name="section-subscribe-fade">
    <div
      v-if="open"
      class="section-subscribe-overlay"
      @click.self="$emit('close')"
    >
      <div class="section-subscribe-modal" role="dialog" aria-modal="true" :aria-label="message">
        <button
          type="button"
          class="section-subscribe-close"
          aria-label="Close"
          @click="$emit('close')"
        >
          <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">
            <path
              d="M6.5 6.5 L17.5 17.5 M17.5 6.5 L6.5 17.5"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
            />
          </svg>
        </button>
        <p class="section-subscribe-message">{{ message }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SectionSubscribeModal',
  props: {
    open: { type: Boolean, default: false },
    message: { type: String, default: 'Subscribe to unlock this section' },
  },
};
</script>

<style scoped>
.section-subscribe-overlay {
  position: fixed;
  inset: 0;
  z-index: 10060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(35, 31, 32, 0.4);
  box-sizing: border-box;
}

.section-subscribe-modal {
  position: relative;
  width: min(280px, 100%);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);
  padding: 18px 28px 16px 16px;
  text-align: center;
}

.section-subscribe-close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #6b6b6b;
  cursor: pointer;
  padding: 0;
  line-height: 0;
}

.section-subscribe-close:hover {
  background: #f0f0f0;
  color: #231f20;
}

.section-subscribe-message {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #231f20;
  line-height: 1.35;
  letter-spacing: 0.01em;
}

.section-subscribe-fade-enter-active,
.section-subscribe-fade-leave-active {
  transition: opacity 0.16s ease;
}

.section-subscribe-fade-enter,
.section-subscribe-fade-leave-to {
  opacity: 0;
}
</style>
